module.exports = __webpack_public_path__ + "static/media/upload-image.f7f24d9a.svg";